class ImageGallery extends Component {
    constructor(el) {
        super(el);
        this.galleryType = el.dataset.imageGalleryType;
        this.swiperElem = this.$find('[data-image-gallery-swiper]');
        this.swiperElem && this.constructSwiper();
    }

    constructSwiper() {
        const swiper = new Swiper(this.swiperElem, {
            watchOverflow: true,
            loop: false,
            autoplay: {
                delay: 4000,
            },
            slidesPerView: 1,
            spaceBetween: 20,
            breakpoints: this.getBreakpointsObject(this.galleryType),
            pagination: {
                el: "[data-image-gallery-pagination]",
                type: "progressbar",
            },
            navigation: {
                nextEl: '.ImageGallery-next',
                prevEl: '.ImageGallery-prev',
            },
        });
    }

    getBreakpointsObject(type) {
        let breakpointsObject = {};

        switch (type) {
            case 'lg':
                breakpointsObject = {
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                };
                break;
            case 'md':
                breakpointsObject = {
                    768: { slidesPerView: 2 },
                };
                break;
            default:
                break;
        }

        return breakpointsObject;
    }
}
